import { data } from "jquery";
import { localAxios } from "../libs/axiosInstances";

export const getMDRTypes = async () => {
	let { data: MDRTypes } = await localAxios.get("/MDRTypes");
	console.log("MDRTypes", MDRTypes);
	return MDRTypes;
};

export const getAccessControl = async () => {
	let { data: accessControl } = await localAxios.get("/accessControl");
	return accessControl;
};

export const getReportToken = async () => {
	let { data: reportToken } = await localAxios.get("/reportToken");
	return reportToken;
};

export const createUser = async (payload) => {
	const { password, cpassword } = payload;
	if (password === cpassword) {
		let { data: status } = await localAxios.post("/createUser", payload);
		return status;
	} else {
		throw new Error("Password does not match!");
	}
};

export const doLogin = async (username, password) => {
	// let response = await authAxios.get('/status');
	let { data: status } = await localAxios.post("/login", {
		username,
		password,
	});
	return status;
};

export const changePassword = async (opassword, npassword, cpassword) => {
	if (npassword === cpassword) {
		let { data: status } = await localAxios.post("/changePassword", {
			opassword,
			npassword,
		});
		return status;
	} else {
		throw new Error("Password does not match!");
	}
};

export const doLogout = () => {
	return localAxios.get("/logout");
};

export const resetUserPassword = async (payload) => {
	const { npassword, rpassword } = payload;
	if (npassword === rpassword) {
		let { data: status } = await localAxios.post("/resetUserPassword", payload);
		return status;
	} else {
		throw new Error("Password does not match!");
	}
};

export const getGateway = async () => {
	let { data: gateway } = await localAxios.get("/gateway");
	console.log("gateway", gateway);
	return gateway;
};

export const getMerchant = async ({ merchantId }) => {
	let { data: merchants } = await localAxios.post("/merchant", { merchantId });
	return merchants;
};

export const getMerchants = async ({ isArchive }) => {
	let { data: merchants } = await localAxios.post("/merchants", {
		isArchive,
	});
	return merchants;
};
export const getReportResellers = async () => {
	let { data: resellers } = await localAxios.get("/report/resellers");
	return resellers;
};

export const getMerchantsv2 = async ({ isArchive }) => {
	let { data } = await localAxios.post("/merchants/v2", {
		isArchive,
	});
	return data;
};

export const createMerchantv2 = async (payload) => {
	let { data } = await localAxios.post("/merchant/createv2", payload, {
		responseType: "blob",
	});
	console.log("payload", payload);
	return data;
};

export const addUsers = async (users, merchantId) => {
	let {
		data: { pendingUsers, existingUsers },
	} = await localAxios.post("/merchant/addUsers", {
		users,
		merchantId,
	});
	return { pendingUsers, existingUsers };
};

export const resendSetup = async (email, merchantId) => {
	let { data: status } = await localAxios.post("/merchant/resendSetup", {
		email,
		merchantId,
	});
	return status;
};

export const removeUser = async (userId) => {
	let { data: status } = await localAxios.post(`/merchant/removeUser`, {
		userId,
	});
	return status;
};

export const removePendingUser = async (email, merchantId) => {
	let { data: status } = await localAxios.post("/merchant/removePending", {
		email,
		merchantId,
	});
	return status;
};

export const addMID = async (merchantId, values) => {
	let { data: status } = await localAxios.post("/merchant/addMID", {
		merchantId,
		...values,
	});
	return status;
};

export const removeMID = async (merchantId, type, currency) => {
	let { data: status } = await localAxios.post("/merchant/removeMID", {
		id: merchantId,
		type,
		currency,
	});
	return status;
};

export const regenKey = async (mid, authKey, shaKey) => {
	let { data } = await localAxios.post("/merchant/regenKey", {
		mid,
		authKey,
		shaKey,
	});
	return data;
};

export const regenRMSKey = async (mid, verifyKey, secretKey) => {
	let { data } = await localAxios.post("/merchant/regenKey", {
		mid,
		verifyKey,
		secretKey,
		type: "rms",
	});
	return data;
};

export const editDetails = async (values) => {
	let { data: status } = await localAxios.post("/merchant/edit", {
		...values,
	});
	return status;
};

export const editGateway = async (payload) => {
	let { data: status } = await localAxios.post(
		"/merchant/editGateway",
		payload
	);
	return status;
};

export const editAdhoc = async (payload) => {
	let { data: status } = await localAxios.post("/merchant/editAdhoc", payload);
	return status;
};

export const archiveMerchant = async (merchantId) => {
	let { data: status } = await localAxios.post("/merchant/archive", {
		merchantId,
	});
	return status;
};

export const addNewRates = async (values) => {
	let { data: status } = await localAxios.post("/merchant/addNewRates", {
		...values,
	});
	return status;
};

export const addRate = async (values) => {
	let { data: status } = await localAxios.post("/merchant/addRate", {
		...values,
	});
	return status;
};

export const editRate = async (merchantId, { rates }, currency) => {
	let { data: status } = await localAxios.post("/merchant/editRate", {
		merchantId,
		rates,
		currency,
	});
	return status;
};

export const editRates = async (values) => {
	let { data: status } = await localAxios.post("/merchant/editRates", {
		...values,
	});
	return status;
};

export const removeRate = async (merchantId, type, currency) => {
	let { data: status } = await localAxios.post("/merchant/removeRate", {
		merchantId,
		type,
		currency,
	});
	return status;
};

export const removeRates = async (payload) => {
	let { data: status } = await localAxios.post(
		"/merchant/removeRates",
		payload
	);
	return status;
};

export const addTransactionFee = async (merchantId, payload) => {
	let { data: status } = await localAxios.post("/merchant/addTransactionFee", {
		merchantId,
		...payload,
	});
	return status;
};

export const getCustomSolution = async (merchantId) => {
	let { data: channels } = await localAxios.post(
		"/merchant/getCustomSolution",
		{
			merchantId,
		}
	);
	return channels;
};

export const createSalesChannel = async (payload) => {
	const { data } = await localAxios.post(
		"/merchant/createSalesChannel",
		payload
	);
	return data;
};

export const archiveSalesChannel = async (payload) => {
	const { data } = await localAxios.post(
		"/merchant/archiveSalesChannel",
		payload
	);
	return data;
};

export const updateCustomSolution = async (payload) => {
	let { data: status } = await localAxios.post(
		"/merchant/updateCustomSolution",
		{
			...payload,
		}
	);
	return status;
};

export const getTransactions = async (filter) => {
	const { data } = await localAxios.post("/merchant/getTransactions", filter);
	return data;
};

export const getCommissions = async (filter) => {
	const { data } = await localAxios.post("/merchant/getCommissions", filter);
	return data;
};

export const getResellers = async () => {
	const { data: resellers } = await localAxios.post("/resellers", {});
	// console.log("reseller", resellers);
	return resellers;
};

export const createReseller = async (values) => {
	const { data: status } = await localAxios.post("/resellers/create", {
		...values,
	});
	return status;
};

export const getResellerUsers = async (resellerId) => {
	const { data: users } = await localAxios.post("/resellers/users", {
		resellerId,
	});
	return users;
};

export const createResellerUser = async (payload) => {
	const { password, cpassword } = payload;
	if (password === cpassword) {
		let { data: status } = await localAxios.post(
			"/createResellerUser",
			payload
		);
		return status;
	} else {
		throw new Error("Password does not match!");
	}
};

export const getBaseRate = async (resellerId) => {
	let endpoint = "/resellers/baseRate";
	if (resellerId) endpoint = `${endpoint}/${resellerId}`;

	const { data: base_rates } = await localAxios.get(endpoint);
	console.log("Baserate", base_rates);
	return base_rates;
};

export const getAllBaseRate = async (types) => {
	const { data: base_rates } = await localAxios.post(`/resellers/allBaseRate`, {
		types,
	});
	return base_rates;
};

export const getCommissionType = async (resellerId) => {
	let endpoint = "/resellers/commissionType";
	if (resellerId) endpoint = `${endpoint}/${resellerId}`;

	const { data } = await localAxios.get(endpoint);
	return data;
};

export const addResellerRates = async (payload) => {
	const { data } = await localAxios.post("/resellers/rates/add", payload);
	return data;
};

export const removeResellerRates = async (payload) => {
	const { data } = await localAxios.post("/resellers/rates/delete", payload);
	return data;
};

export const getResellerRateUpdates = async (resellerId) => {
	const { data } = await localAxios.post("/resellers/rates/update", {
		resellerId,
	});
	return data;
};

export const getResellerPaymentGatewayUpdate = async (resellerId) => {
	const { data } = await localAxios.post("/resellers/update", {
		resellerId,
	});
	return data;
};

export const scheduleResellerRateUpdate = async (payload) => {
	const { data } = await localAxios.post("/resellers/rates/schedule", payload);
	return data;
};

export const removeResellerRateUpdate = async (payload) => {
	const { data } = await localAxios.post(
		"/resellers/rates/schedule/delete",
		payload
	);
	return data;
};

export const getBaseToAdhocPaymentMethods = async (type) => {
	const { data } = await localAxios.get(`/resellers/baseToAdhocPaymentMethods`);
	return data;
};

export const getTotalCommissions = async (payload) => {
	const { data } = await localAxios.post(
		"/resellers/totalCommissions",
		payload
	);
	return data;
};

export const getSettlements = async (payload) => {
	const { data } = await localAxios.post("/merchant/getSettlements", payload);
	return data;
};

export const getReport = async (payload) => {
	const { data } = await localAxios.post("/merchant/getReport", payload);
	return data;
};

export const getReportList = async (payload) => {
	const { data } = await localAxios.post("/merchant/getReportList", payload);
	return data;
};

export const ipay88Key = async (merchantId, values) => {
	const { data } = await localAxios.post("/merchant/ipay88key", {
		merchantId,
		...values,
	});
	return data;
};
export const applicationCodeRMS = async (merchantId, values) => {
	const { data } = await localAxios.post("/merchant/rmsApplicationCode", {
		merchantId,
		...values,
	});
	return data;
};

export const applicationV2keyUQPay = async (merchantId, values) => {
	const { data } = await localAxios.post("/merchant/addUqpayV2Keys", {
		merchantId,
		...values,
	});
	return data;
};

export const secretKeyNetzme = async (merchantId, values) => {
	const { data } = await localAxios.post("/merchant/AddNetzmeKeys", {
		merchantId,
		...values,
	});
	return data;
};
